import { render } from "./OurLocation.vue?vue&type=template&id=3161fe3c&scoped=true"
import script from "./OurLocation.vue?vue&type=script&lang=js"
export * from "./OurLocation.vue?vue&type=script&lang=js"

import "./OurLocation.vue?vue&type=style&index=0&id=3161fe3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3161fe3c"]])

export default __exports__